import React from 'react';
import PropTypes from 'prop-types';
import styles from './pageHeader.module.scss';

const headerTitle = (isLargeTitle, title) => {
  if (isLargeTitle) {
    return <h1 dangerouslySetInnerHTML={{ __html: title || '' }} />;
  }
  return <h2 dangerouslySetInnerHTML={{ __html: title || '' }} />;
};

const PageHeaderTextSection = ({
  title,
  subtitle,
  headerImageLink,
  useLargeTitle,
  children,
  cxtClassName,
}) => {
  return (
    <div
      className={`${cxtClassName ? styles[cxtClassName] : ''} ${
        styles.pageHeaderTextSection
      }`}
    >
      <div className={`container ${styles.container}`}>
        {headerImageLink && (
          <img
            alt="ECRI"
            className={styles.headerImage}
            src={headerImageLink}
            width="150"
            height="150"
          />
        )}

        <div className="row">
          <div
            className={`col-xs-12 col-lg-${headerImageLink ? 9 : 12} ${
              headerImageLink ? 'col-xs-12 col-sm-8 col-md-7 ' : ''
            }`}
          >
            {headerTitle(useLargeTitle, title)}
            {subtitle && <h4>{subtitle}</h4>}
            {children && <div>{children}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

PageHeaderTextSection.propTypes = {
  title: PropTypes.string.isRequired,
  headerImageLink: PropTypes.string,
  useLargeTitle: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};

PageHeaderTextSection.defaultProps = {
  headerImageLink: null,
  useLargeTitle: false,
  children: null,
};

export default PageHeaderTextSection;
